import { render, staticRenderFns } from "./ProjectConfig.vue?vue&type=template&id=948fc9e2"
import script from "./ProjectConfig.vue?vue&type=script&lang=js"
export * from "./ProjectConfig.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfig.vue?vue&type=style&index=0&id=948fc9e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports